// extracted by mini-css-extract-plugin
export var chatHtmlText = "_pc-2";
export var chatLink = "_pc-0";
export var chatText = "_pc-1";